import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './core/components/navbar/navbar.component';
import { ContextbarComponent } from './core/components/contextbar/contextbar.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { MaintenanceBannerComponent } from './core/components/maintenance-banner/maintenance-banner.component';
import { StoreService } from './core/services/store.service';
import { PrimeNGConfig } from 'primeng/api';
import { GtmService } from './core/services/gtm.service';
import { TranslocoService } from '@jsverse/transloco';
import { fr, en, es, it } from './core/i18n/app-languages';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  imports: [CommonModule, FormsModule, RouterOutlet, NavbarComponent, ContextbarComponent, FooterComponent, MaintenanceBannerComponent],
})
export class AppComponent implements OnInit {
  title = 'g2fm';

  private setPrimeNgLocale(base: string) {
    switch ((base || 'fr').toLowerCase()) {
      case 'en':
        this.primeNGConfig.setTranslation(en);
        break;
      case 'es':
        this.primeNGConfig.setTranslation(es);
        break;
      case 'it':
        this.primeNGConfig.setTranslation(it);
        break;
      default:
        this.primeNGConfig.setTranslation(fr);
    }
  }


  constructor(
    private storeService: StoreService,
    private primeNGConfig: PrimeNGConfig,
    private gtm: GtmService,
    private translocoService: TranslocoService,
  ) {
    const savedLangRaw = localStorage.getItem('selectedLanguage');
    let base = 'fr';
    if (savedLangRaw) {
      try {
        const saved = JSON.parse(savedLangRaw);
        if (saved && typeof saved.code === 'string') {
          base = saved.code.split('_')[0];
        }
      } catch {}
    }
    this.setPrimeNgLocale(base);
    this.translocoService.setActiveLang(base);

    if (!this.storeService.isLogged && localStorage.getItem('isLogged') === 'true' && localStorage.getItem('isContractSelected') !== 'true' && localStorage.getItem('selectedContract') === '{}') {
      localStorage.clear();
    } else if (localStorage.getItem('isLogged') === 'false') {
      localStorage.clear();
    }
  }

  ngOnInit(): void {
    this.gtm.loadGtm();
  }

  get isLogged() {
    return this.storeService.isLogged;
  }

  get isContractSelected() {
    return this.storeService.isContractSelected;
  }
}
